import React from 'react';
import * as Yup from 'yup';
import { PropTypes } from 'prop-types';
import Radios from '@atoms/Radios';
import { H4, H5 } from '@styled';

export const messagesSettingsFieldsEnableValidationSchema = {
    messages: Yup.string().required(),
};

const MessagesSettingsFieldsEnable = ({ values }) => (
    <>
        <H5 className="mt-4 mb-3">Networking Platform Messaging</H5>
        <p className="display8 mb-3">Choose whether or not you'd like to use ICSC's messaging feature.</p>
        <Radios
            name="messages"
            value={values.messages}
            options={[
                {value: 'true', label: 'Enable Messaging (ICSC Members can send you messages)'},
                {value: 'false', label: 'Disable Messaging (ICSC Members cannot send you messages)'},
            ]}
            required
        />
    </>
);

MessagesSettingsFieldsEnable.propTypes = {
    values: PropTypes.object,
};

export default MessagesSettingsFieldsEnable;
